/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Directive, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';
import {AbstractFilterStateModel} from './abstract-filter-state.model';

@Directive()
export abstract class AbstractFilterComponent<T extends AbstractFilterStateModel> {
    @Input() public filterName: string;
    @Input() public formatWithoutCode: boolean;
    @ViewChild(NgbDropdown)
    public dropdown: NgbDropdown;
    @Output() public filterEvent = new EventEmitter<T>();
    public state: T = {} as T;

    get isFilterActive(): boolean {
        return this.state.isActive;
    }

    protected constructor() {
    }

    resetFilter(): void {
        this.state = {
            filterName: this.filterName,
            isActive: false
        } as T;
    }

    // TODO: CTWILS-3156 - update this class to use StatefulComponent
    storeState(state?: Partial<T>): void {
        const baseState: AbstractFilterStateModel = {
            filterName: this.filterName,
            isActive: false
        };

        // `Object.assign` instead of spread operator on generics, it was introduced in later TypeScript versions
        this.state = Object.assign(baseState, this.state, state);
    }

    emit(opened: boolean): void {
        if (!opened) {
            this.emitSearch();
        }
    }

    closeAndSearch(): void {
        this.dropdown.close();
    }

    clear(): void {
        this.resetFilter();
        this.closeAndSearch();
    }

    getCssButton(): string {
        return this.dropdown?.isOpen() ? 'open' : (this.isFilterActive ? 'active' : '');
    }

    getCypressTag(): string {
        return `${this.filterName}-filter`;
    }

    getCypressTagElement(elem: string): string {
        return `${this.filterName}-filter-${elem}`;
    }

    abstract emitSearch(): void;

    abstract initFilter(value: T): void;
}
